import { AsyncAction } from '../../base-classes/asyncAction';
import { PollenProvider } from '../providers/pollenProvider.js';
import { mapParamsToObject } from '../../utilities/mapParamsToObject';

export const GET_POLLEN_BY_LATLON = new AsyncAction('GET_POLLEN_BY_LATLON');

export function getPollenByLatLon(...params)
{
    let paramsObject = {
        latitude: undefined,
        longitude: undefined,
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        stdParameters: undefined,
        verbose: undefined,
        refresh: undefined
    };

    paramsObject = mapParamsToObject(params, paramsObject); 

    const payload = getPollen(paramsObject);
    return {
        type: GET_POLLEN_BY_LATLON.base
        , payload
    };
}

async function getPollen({latitude, longitude, baseUrl, authId, secret, stdParameters, verbose, refresh})
{
    const op = new PollenProvider(baseUrl, authId, secret);
    const results = await op.getPollen(latitude, longitude, stdParameters, verbose, refresh);
    return results;
}
